import authorProfileData from './author.json';

export const authorProfile = authorProfileData;

